type Category =
  | 'greeting'
  | 'personality'
  | 'role'
  | 'rules'
  | 'language-behavior';

export const getAgentSettingsReferenceKey = (
  category: Category,
  languageCode: string,
) => `${category}/${languageCode}`;
